import { call, put, takeEvery, takeLatest } from "redux-saga/effects";

// Login Redux States
import { LOGIN_PARTICIPANT_USER, LOGOUT_PARTICIPANT_USER } from "./actionTypes";
import { participantLoginError, loginParticipantSuccess, logoutParticipantUserSuccess } from "./actions";


import {
  postParticipantLogin,
} from "helpers/backend_api_helper";


function* loginUser({ payload: { user, type, callback } }) {
  try {
    const response = yield call(postParticipantLogin, user, type);
    if(response?.status_code == '200'){
      sessionStorage.setItem("authUser", JSON.stringify(response));

    }
    callback && callback(response);
    yield put(loginParticipantSuccess(response));
    // window.location.reload()

  } catch (error) {
    yield put(participantLoginError(error?.response?.data?.message || "Server Error"));
  }
}

function* logoutUser({ payload: { history } }) {
  try {
    sessionStorage.removeItem("authUser");

    if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
      const response = yield call();
      yield put(logoutParticipantUserSuccess(response));
    }
    history('/');
  } catch (error) {
    yield put(participantLoginError(error));
  }
}


function* authSaga() {
  yield takeEvery(LOGIN_PARTICIPANT_USER, loginUser);
  yield takeEvery(LOGOUT_PARTICIPANT_USER, logoutUser);
}

export default authSaga;
